var render, staticRenderFns
import script from "./Spheres360List.vue?vue&type=script&lang=js&"
export * from "./Spheres360List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5deb772e')) {
      api.createRecord('5deb772e', component.options)
    } else {
      api.reload('5deb772e', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Sphere360/resources/vue/Spheres360List.vue"
export default component.exports